import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import {
  CohortFragment,
  InspectErrorFragment,
  InspectSubjectTableFieldsFragment,
} from './fragments';

export const INSPECT_SUBJECT = gql`
  mutation inspectSubject($input: InspectSubjectInput!) {
    inspectSubject(input: $input) {
      data {
        inspectTable {
          ...InspectSubjectTableFields
        }
      }
      exportUrl
      errors {
        ...ErrorFields
      }
      error {
        ...InspectErrorFields
      }
    }
  }
  ${InspectSubjectTableFieldsFragment}
  ${ErrorFragment}
  ${InspectErrorFragment}
`;

export const CREATE_NAMED_COHORT = gql`
  mutation NamedCohortCreate($input: NamedCohortCreateInput!) {
    namedCohortCreate(input: $input) {
      entity {
        ...CohortFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${CohortFragment}
  ${ErrorFragment}
`;

export const EDIT_NAMED_COHORT = gql`
  mutation NamedCohortEdit($input: NamedCohortEditInput!) {
    namedCohortEdit(input: $input) {
      entity {
        ...CohortFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${CohortFragment}
  ${ErrorFragment}
`;

export const DISABLE_NAMED_COHORT = gql`
  mutation NamedCohortDisable($input: NamedCohortDisableInput!) {
    namedCohortDisable(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const NAMED_COHORT_ADD_CATEGORY = gql`
  mutation NamedCohortAddCategory($input: NamedEntityEditCategoryInput!) {
    namedCohortAddCategory(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const NAMED_COHORT_REMOVE_CATEGORY = gql`
  mutation NamedCohortRemoveCategory($input: NamedEntityEditCategoryInput!) {
    namedCohortRemoveCategory(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;
